import React from 'react';
import styled from 'styled-components';
import { SectionParent, H3, H1, BlueButton } from '../../StyledComponents';
import ZeroTouch from '../../../assets/v2/manage/group-18.svg';
import RemoteSupport from '../../../assets/v2/manage/group-14.svg';
import ApplicationLockdown from '../../../assets/v2/manage/group-12.svg';
import DeviceMonitoring from '../../../assets/v2/manage/group-21.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import DeviceHealthAssessment from '../../../assets/v2/manage/group-22.svg';
import Alerts from '../../../assets/v2/manage/group-52.svg';
import DeviceSecurity from '../../../assets/v2/manage/group-212.svg';
import DeviceGroups from '../../../assets/v2/manage/group-30.svg';
import { navigate } from '@reach/router';
const Section = styled(SectionParent)`
  display: grid;
  position: relative;
  justify-items: center;
  background-color: #fff;
  padding-bottom: 3rem !important;
`;

const BlueButtonWrapper = styled.div`
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    justify-self: center;
  }
`;

const StyledImg = styled(LazyLoadImage)`
  height: 46px;
`;
const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin-top: 3rem;
  grid-gap: 6rem 10rem;
  @media (max-width: 1920px) {
    grid-gap: 3rem 6rem;
  }

  @media (max-width: 1024px) {
    grid-gap: 4rem 8rem;
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
  @media (max-width: 520px) {
    grid-template-columns: repeat(1, 1fr);
    margin-top: 2.5rem;
  }
`;

const GridItem = styled.div`
  grid-column: span 1;
  border-radius: 5px;
`;

const GridItemContent = styled(H3)`
  font-family: 'Nunito Sans', sans-serif;
  margin-bottom: 2rem;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.79;
  letter-spacing: normal;
  text-align: left;
  color: #736e79;
  @media (max-width: 768px) {
    padding-left: 10%;
    padding-right: 10%;
    text-align: center;
  }
`;

const TitlesContainer = styled.div`
  padding-top: 0.5rem;
  @media (max-width: 768px) {
    text-align: center;
    padding-left: 0rem;
  }
`;
const GridTitle = styled.div`
  font-size: 22px;
  font-weight: 500;
  min-height: 2em;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #26315c;
  @media (max-width: 520px) {
    min-height: 2.5rem;
  }
`;

const ImgWrapper = styled.div`
  display: grid;
  align-items: center;
  @media (max-width: 768px) {
    justify-items: center;
  }
`;

const SectionTitle = styled(H1)`
  padding-top: 2rem;
  @media (max-width: 520px) {
    text-align: center;
  }

  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.92;
  letter-spacing: normal;
  color: #5f4aa1;
`;

export default () => (
  <>
    <Section>
      <SectionTitle>Features</SectionTitle>
      <GridContainer>
        <GridItem>
          <ImgWrapper>
            <StyledImg src={ZeroTouch} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Zero-touch Provisioning</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Provision your devices simply by using QR code and NFC-based
            enrollment.
          </GridItemContent>
        </GridItem>
        <GridItem>
          <ImgWrapper>
            <StyledImg src={RemoteSupport} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Remote Support</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Get complete access to your devices: remotely view and control
            devices in the field.
          </GridItemContent>
        </GridItem>
        <GridItem>
          {' '}
          <ImgWrapper>
            <StyledImg src={ApplicationLockdown} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Application Lockdown</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Complete backend control which allows only admin-approved
            applications to be installed.
          </GridItemContent>
        </GridItem>
        <GridItem>
          <ImgWrapper>
            <StyledImg src={DeviceMonitoring} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Device Monitoring</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Individual device telemetry graphs such as Battery, Memory,
            Connectivity are available on a per device basis
          </GridItemContent>
        </GridItem>
        <GridItem>
          <ImgWrapper>
            <StyledImg src={Alerts} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Alerts</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Generate automated alerts when devices have security, battery and
            network issues.
          </GridItemContent>
        </GridItem>
        <GridItem>
          <ImgWrapper>
            <StyledImg src={DeviceSecurity} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Device Security State Assessment</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Esper accesses OS, hardware and bootloader conditions to generate
            assessment.
          </GridItemContent>
        </GridItem>
        <GridItem>
          <ImgWrapper>
            <StyledImg src={DeviceGroups} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Device Groups</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Enterprises can group devices based on location, software version,
            hardware type and more.
          </GridItemContent>
        </GridItem>
      </GridContainer>

      <BlueButtonWrapper>
        <BlueButton
          id="manage__get_started"
          onClick={() => navigate('/signup')}
        >
          Get Started
        </BlueButton>
      </BlueButtonWrapper>
    </Section>
  </>
);
